export default __webpack_public_path__ + "static/media/Gem.262c7500.jpeg";